"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DebounceHook = _interopRequireDefault(require("../DebounceHook"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelInputQuality = props => {
  // PROPS
  const {
    className = '',
    disableDelay = false,
    disabled = false,
    input,
    label = null,
    modal = null,
    options = [],
    square = false,
    validation = false
  } = props;
  // STATE
  const [currentValue, setCurrentValue] = (0, _react.useState)(input.value);
  const debouncedSearchTerm = (0, _DebounceHook.default)(currentValue, disableDelay ? 0 : 500);
  const squareClass = square ? 'square' : '';
  const clickOption = (_e, val) => {
    if (!disabled) {
      if (input.value === val) setCurrentValue('');else setCurrentValue(val);
    }
  };
  (0, _react.useEffect)(() => {
    if (input.onChange && input.value !== currentValue && !disableDelay && options.length > 0) {
      input.onChange(currentValue);
    }
  }, [debouncedSearchTerm]);
  (0, _react.useEffect)(() => {
    if (input.onChange && input.value !== currentValue && disableDelay && options.length > 0) {
      input.onChange(currentValue);
    }
  }, [currentValue]);
  const getClass = val => {
    if (val.bgClass) {
      return `${val.bgClass} bgSelected`;
    }
    return `${val.brdClass} brdSelected`;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-quality-container ${className}`
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    className: "brixel-label",
    "data-testid": "label"
  }, label)), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f"
  }, options.map((val, i) => (/*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `opt_${i.toString()}`
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "notranslate",
    "data-validation": validation,
    name: input.name
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `step ${currentValue === val.value ? `active ${getClass(val)}` : 'inactive'} ${squareClass} ${disabled ? 'disabled' : ''}`,
    onClick: e => clickOption(e, val.value)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "contentSquare"
  }, val.label)))))), modal && (/*#__PURE__*/_react.default.createElement("span", {
    onClick: e => modal.func ? modal.func(e) : '',
    className: `message ${modal.func ? 'cur-poi' : ''} ${modal.className || ''}`,
    dangerouslySetInnerHTML: {
      __html: modal.message || ''
    }
  })));
};
var _default = exports.default = BrixelInputQuality;